import 'javascripts/showroom_fiat_v2/new_vehicles_index';
import 'stylesheets/showroom_fiat_v2/new_vehicles_index';
